import isPdf from '@/lib/is-pdf.js';
import queryString from 'query-string';

function getDomain(url) {
	url = url || window.location.href;
	let href = url;

	if (isPdf()) {
		href = new URL(window.location.href);
		let qs = queryString.parse(href.search);
		if (qs.file) {
			href = qs.file.replace('https://api.underlineme.com/proxy/', '');
		}
	}
	url = new URL(href);
	return url.hostname;
}

export default getDomain;
